export interface PaginationState {
  page: number;
  pageSize: number;
}

export const parsePaginationParams = (
  params: URLSearchParams,
  initialValue: PaginationState = { page: 1, pageSize: 10 },
): PaginationState => {
  const parse = (key: string, fallback: number) => {
    const value = Number.parseInt(params.get(key) ?? '', 10);
    return Math.max(1, Number.isFinite(value) ? value : fallback);
  };
  return { page: parse('page', initialValue.page), pageSize: parse('pageSize', initialValue.pageSize) };
};
